var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.037,
    height: 50.213,
    viewBox: "0 0 73.037 50.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_6_",
    "data-name": "email (6)",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5560",
    "data-name": "Group 5560",
    transform: "translate(48.414 89.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5559",
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10153",
    "data-name": "Path 10153",
    d: "M339.392,161.119l24.623,15.566V144.9Z",
    transform: "translate(-339.392 -144.896)",
    fill: "#51aabc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5562",
    "data-name": "Group 5562",
    transform: "translate(0 89.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5561",
    "data-name": "Group 5561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10154",
    "data-name": "Path 10154",
    d: "M0,144.9v31.789l24.623-15.566Z",
    transform: "translate(0 -144.896)",
    fill: "#51aabc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564",
    transform: "translate(0.137 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5563",
    "data-name": "Group 5563",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10155",
    "data-name": "Path 10155",
    d: "M69.3,80H5.388A4.508,4.508,0,0,0,.96,83.885l36.382,23.97,36.382-23.97A4.508,4.508,0,0,0,69.3,80Z",
    transform: "translate(-0.96 -80)",
    fill: "#51aabc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5566",
    "data-name": "Group 5566",
    transform: "translate(0.146 108.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5565",
    "data-name": "Group 5565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10156",
    "data-name": "Path 10156",
    d: "M45.111,277.925l-6.459,4.254a2.292,2.292,0,0,1-2.511,0l-6.459-4.259L1.024,296.047A4.5,4.5,0,0,0,5.443,299.9H69.35a4.5,4.5,0,0,0,4.419-3.853Z",
    transform: "translate(-1.024 -277.92)",
    fill: "#51aabc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconEmail);
export default __webpack_public_path__ + "static/media/menu_icon_email.8aa8f727.svg";
export { ForwardRef as ReactComponent };